exports.TIMING_KEYS = [ "", "fetchStart", "domainLookupStart", "domainLookupEnd", "connectStart", "connectEnd", "requestStart", "responseStart", "responseEnd", "", "domInteractive", "", "domContentLoadedEventEnd", "", "loadEventStart", "", "msFirstPaint", "secureConnectionStart" ];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_alife-logger@1.8.30@alife-logger/lib/common/constants.js
// module id = GuMX
// module chunks = 68